import { render, staticRenderFns } from "./HorizontalStackedChart.vue?vue&type=template&id=5f28c322&lang=pug&"
import script from "./HorizontalStackedChart.vue?vue&type=script&lang=ts&"
export * from "./HorizontalStackedChart.vue?vue&type=script&lang=ts&"
import style0 from "./HorizontalStackedChart.vue?vue&type=style&index=0&id=5f28c322&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports